import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import {
  USER_ACCOUNT_SETTINGS_KEY,
  UpdateUserParams,
  UpdateUserResponse,
  updateUserInfo,
} from '../utils/backend-api/settings';

export default function useUpdateUserInfo() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, data, isLoading, isError } = useMutation(
    (params: UpdateUserParams) => updateUserInfo(params),
    {
      onSuccess: (data: UpdateUserResponse) => {
        queryClient.invalidateQueries(USER_ACCOUNT_SETTINGS_KEY);
        if (data.emailVerificationRequired) {
          navigate('/email-confirmation');
        } else {
          toast.success(data.message);
        }
      },
      onError: (data: [string]) => {
        toast.error(data.join(' '));
      },
    }
  );
  return { mutate, data, isLoading, isError };
}
